import script from "./AddressForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressForm.vue?vue&type=script&setup=true&lang=js"

import "./AddressForm.vue?vue&type=style&index=0&id=2e37cbec&lang=less"

const __exports__ = script;

export default __exports__